// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import AirlineCodeSelectController from "./airline_code_select_controller"
application.register("airline-code-select", AirlineCodeSelectController)

import CountrySelectController from "./country_select_controller"
application.register("country-select", CountrySelectController)

import FadeController from "./fade_controller"
application.register("fade", FadeController)

import FileSubmitController from "./file_submit_controller"
application.register("file-submit", FileSubmitController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import CampaignEligibilityController from "./campaign_eligibility_controller"
application.register("campaign-eligibility", CampaignEligibilityController)

import TypeformController from "./typeform_controller"
application.register("typeform", TypeformController)

import ScreenCaptureController from "./screen_capture_controller"
application.register("screen-capture", ScreenCaptureController)

import ValidationPageController from "./validation_page_controller"
application.register("validation-page", ValidationPageController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import TextScrambleController from "./text_scramble_controller"
application.register("text-scramble", TextScrambleController)

import TravelersCompassItemController from "./travelers_compass_item_controller"
application.register("travelers-compass-item", TravelersCompassItemController)

import FaqAccordionController from "./faq_accordion_controller"
application.register("faq-accordion", FaqAccordionController)

import GoogleAnalyticsController from "./google_analytics_controller"
application.register("google-analytics", GoogleAnalyticsController)

import RemovableController from "./removable_controller"
application.register("removable", RemovableController)
